import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication/authentication.service';

@Injectable({
    providedIn: 'root',
})
export class SessionInfoResolver {
    constructor(private authenticationService: AuthenticationService) { }

    resolve() {
        return this.authenticationService.initSessionInfo();
    }
}
